<template>
    <b-row class="row justify-content-center">
        <b-col cols="12">
            <div class="min-height-100vh has-header d-flex align-items-center">
                <div class="form-content form-team-content w-100 white-content">
                    <b-row>
                        <b-col cols=12>
                            <div class="h1 mb-4 text-center text-uppercase">{{ $t('header.mi_abono') }} / Cambiar Asiento</div>
                        </b-col>
                        <b-col cols="12" v-if="! zona">
                            <SelectRegionComponent
                                @regionSeleccionada="regionSeleccionada"
                            />
                        </b-col>
                        <b-col cols="12" v-if="zona">
                            <SelectSeatComponent
                                :zona="zona"
                                @clickAsiento="asientoSeleccionado"
                                @volver="zona = null; asiento = null"
                            />
                        </b-col>
                        <b-col cols="12" class="mt-3" v-if="asiento">
                            <b-button block @click="cambiarAsiento" :disabled="loading">Cambiar asiento</b-button>
                        </b-col>
                    </b-row>                    
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import SelectRegionComponent from '@/components/frontend/abonos/lfp/nuevo/SelectRegionComponent.vue';
import SelectSeatComponent from '@/components/frontend/abonos/lfp/nuevo/SelectSeatComponent.vue';

export default {
    props: ['id_persona', 'pin'],
    data() {
        return {
            asiento: null,
            zona: null,
            loading: false
        }
    },
    mounted() {
        if(this.id_persona == undefined) {
            this.$router.push('/mi-abono');
        }
    },
    methods: {
        cambiarAsiento(){
            this.loading = true;
            const params = {
                filters: {},
                id_persona: this.id_persona,
                pin: this.pin,
                id_area: this.zona.lfp_id,
                id_asiento: parseInt(this.asiento.asiento.seat_id)
            }

            this.$store.dispatch(this.config.getVuexAlias('front.abonados.lfp.cambiar-asiento'), params).then(res => {
                this.$toast.success('Butaca/s cambiada/s correctamente.');
            }).catch(error => {
                this.$toast.error('Butaca/s elegida/s por otro usuario.');
            }).finally(() => {
                this.loading = false;
                this.$router.push({ name: 'mi-abono', params: { pin: this.pin,  id_persona: this.id_persona} });
            });
        },
        regionSeleccionada(zona) {
            this.zona = zona;
        },
        asientoSeleccionado(asientos) {
            if(asientos.length > 0) {
                this.asiento = asientos[0];
            } else {
                this.asiento = null;
            }
        }
    },
    components: {
        SelectRegionComponent, SelectSeatComponent
    }
}
</script>